// Special characters in files causes Chrome to not link files in workspace properly
// Please put every special characters here
var SpecialCharacterMap = {
  "leftArrow"         : "→"
};
